import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useToasts } from 'react-toast-notifications';

import { AI_QUOTA_USAGE_STATUS, useAIQuota } from 'core/hooks/useAIQuota';
import type { ToastAppearance } from 'ui';

type AddToast = (message: string, options: { appearance: ToastAppearance; autoDismiss: boolean }) => void;

export function createTeacherToolsQuotaFirstUseToast(): () => void {
  let hasBeenShown = false;

  return function useTeacherToolsQuotaFirstUseToast(): void {
    const { t } = useTranslation(['chatbot']);
    const { addToast }: { addToast: AddToast } = useToasts();
    const { usage } = useAIQuota();
    const isUnused = usage?.status === AI_QUOTA_USAGE_STATUS.UNUSED;

    useEffect(() => {
      if (!isUnused || hasBeenShown) {
        return;
      }
      hasBeenShown = true;
      addToast(t('chatbot:quota_teacher_first_use_toast'), { appearance: 'info', autoDismiss: true });
    }, [addToast, isUnused, t]);
  };
}

/** Only the panel and the tool setup call it: the output, the History and the quiz do not show it. */
const useTeacherToolsQuotaFirstUseToast = createTeacherToolsQuotaFirstUseToast();

export default useTeacherToolsQuotaFirstUseToast;
